import { Injectable } from '@angular/core';
import { User } from './nswag/nswagclient';
import { UserRoles } from '../models/userRole';

@Injectable({
  providedIn: 'root'
})
export class UserAuthorizationService {
  isUserAdmin(user: User | null | undefined, companyId: string, oldRoles: boolean = false): boolean {
    if (!user) {
      return false;
    }

    if (user.isGlobalAdmin) {
      return true;
    }

    if (oldRoles) {
      return user.role === UserRoles.admin;
    }

    return (user.companyRoles ?? []).some(role =>
      role.companyId === companyId && role.role === UserRoles.admin
    );
  }

  isUserAnyRoleAdmin(user: User | null | undefined, oldRoles: boolean = false): boolean {
    if (!user) {
      return false;
    }

    if (user.isGlobalAdmin) {
      return true;
    }

    if (oldRoles) {
      return user.role === UserRoles.admin;
    }

    return (user.companyRoles ?? []).some(role => role.role === UserRoles.admin);
  }

  isUserEditorOrAdmin(user: User | null | undefined, companyId: string, oldRoles: boolean = false): boolean {
    if (!user) {
      return false;
    }

    if (user.isGlobalAdmin) {
      return true;
    }

    if (oldRoles) {
      return user.role === UserRoles.admin || user.role === UserRoles.editor;
    }

    return (user.companyRoles ?? []).some(role =>
      role.companyId === companyId
      && (role.role === UserRoles.admin || role.role === UserRoles.editor)
    );
  }

  isUserAnyRoleEditorOrAdmin(user: User | null | undefined, oldRoles: boolean = false): boolean {
    if (!user) {
      return false;
    }

    if (user.isGlobalAdmin) {
      return true;
    }

    if (oldRoles) {
      return user.role === UserRoles.admin || user.role === UserRoles.editor;
    }

    return (user.companyRoles ?? []).some(role =>
      role.role === UserRoles.admin || role.role === UserRoles.editor
    );
  }
}
